import { toast } from "react-toastify";

const initialState = {
  loading: false,
  error: null,
  list: null,
};

export default function comment(state = initialState, action) {
  let { type, data } = action;
  switch (type) {
    case "comment/list":
      return { ...state, loading: false, error: null };
    case "comment/update":
      return { ...state, loading: false, error: null };
    case "comment/add":
      toast.success("ثبت درخواست با موفقیت انجام شد");
      return { ...state, loading: false, error: null };
    case "comment/delete":
      return { ...state, loading: false, error: null };
    case "comment/info":
      return {
        ...state,
        loading: false,
        list: data,
        error: null,
      };
    case "comment/loading":
      return { ...state, loading: true };
    case "comment/error":
      toast.error(data.message);
      return { ...state, loading: false, error: data.message };
    default:
      return state;
  }
}
